import {
  SAVE_MEDITATION_GRADIENT,
  GET_HOST_NAME,
  NOTE_BEING_SAVED,
  NOTE_SAVING_SUCCESS,
} from 'constants/types';

const initialState = {
  gradient: null,
  hostName: '',
  isSavingNote: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_MEDITATION_GRADIENT: {
      return {
        ...state,
        gradient: action.payload,
      }
    }
    case GET_HOST_NAME: {
      return {
        ...state,
        hostName: action.payload,
      }
    }
    case NOTE_BEING_SAVED: {
      return {
        ...state,
        isSavingNote: true,
      }
    }
    case NOTE_SAVING_SUCCESS: {
      return {
        ...state,
        isSavingNote: false,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentMeditation.js